import type { SVGProps } from 'react';

/**
 * The two run icons of the source design ("Justdroppit Flow v3"): a droplet in
 * a square for print, a needle over a thread for embroidery. Used wherever
 * the run is named — the choice tiles, the compact bar — so it reads the
 * same everywhere.
 */

function base(props: SVGProps<SVGSVGElement>): SVGProps<SVGSVGElement> {
  return {
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': true,
    ...props,
  };
}

export function PrintRunIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base(props)}>
      <rect x="3.5" y="3.5" width="17" height="17" rx="2" />
      <path d="M12 7.5c-2 3-3.5 4.5-3.5 6.5a3.5 3.5 0 0 0 7 0c0-2-1.5-3.5-3.5-6.5z" />
    </svg>
  );
}

export function EmbroideryRunIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...base(props)}>
      <path d="M5 19 17 7" />
      <circle cx="17.5" cy="6.5" r="1.5" />
      <path d="M3.5 14.5c3-1 5 2 8 0s4-3 7-1" />
    </svg>
  );
}
